<template>
  <v-card class="elevation-0">
    <v-card-text>
      <v-row class="mb-4 ta-center">
        <v-col>
          <div class="fs-32 fw-500">Let's start your <strong>search</strong>!</div>
        </v-col>
      </v-row>
      <v-row class="mb-4">
        <v-col>
          <div class="fs-16 fw-400">Complete the following questionnaire to help us understand which providers would be the best fit for your family.</div>
        </v-col>
      </v-row>
      <v-row class="mb-4">
        <v-col>
          <div class="fs-16 fw-600">Ready to get started?</div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  props: ['search']
}

</script>
